module.exports = {
          srcSet: __webpack_public_path__ + "56ea38b507fb6a42048ee24a5c1978c9-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "56ea38b507fb6a42048ee24a5c1978c9-90.png",width: 90,height: 6}],
          src: __webpack_public_path__ + "56ea38b507fb6a42048ee24a5c1978c9-90.png",
          toString:function(){return __webpack_public_path__ + "56ea38b507fb6a42048ee24a5c1978c9-90.png"},
          
          width: 90,
          height: 6
        }